const toWesternDigits = (value: string): string => value
  .replace(/[\u0660-\u0669]/g, digit => String(digit.charCodeAt(0) - 0x0660))
  .replace(/[\u06F0-\u06F9]/g, digit => String(digit.charCodeAt(0) - 0x06F0));

export const normalizeWhatsAppNumber = (phone: string): string => {
  const raw = toWesternDigits(String(phone || '').trim());
  let digits = raw.replace(/\D/g, '');

  if (raw.startsWith('00')) digits = digits.slice(2);
  if (/^01\d{9}$/.test(digits)) digits = `20${digits.slice(1)}`;
  else if (/^1\d{9}$/.test(digits)) digits = `20${digits}`;

  return /^[1-9]\d{7,14}$/.test(digits) ? digits : '';
};

export const buildWhatsAppLink = (phone: string): string => {
  const normalized = normalizeWhatsAppNumber(phone);
  return normalized ? `https://wa.me/${normalized}` : '';
};
